const PREFERENCE_CONSENT_KEYS = ['preferences', 'preference', 'functional', 'functionality'] as const

/**
 * Returns `true` when the CookieYes consent store contains an accepted preference/functional category.
 * Always returns `false` on the server.
 */
export const hasPreferenceConsent = (): boolean => {
	if (!import.meta.client) return false

	const store = window.cookieyes?._ckyConsentStore
	if (!(store instanceof Map)) return false

	return PREFERENCE_CONSENT_KEYS.some((key) => store.get(key) === 'yes')
}

/** Composable that exposes cookie-preference consent helpers. */
export const useCookiePreferenceConsent = () => {
	return {
		hasPreferenceConsent,
	}
}
